import React from "react";
import "./About.css";
// import aboutImage from "../assets/about-image.jpg";
// import ceoImage from "../assets/ceo.jpg";

const About = () => {
  return (
    <section className="about-wrapper">

      {/* About Us Section */}
      <div className="about-section">
        <div className="about-text">
          <h2>About Us</h2>
          <p className="quote">"Your safety is our commitment. We secure what matters most."</p>
          <p>
            SHIELDON SECURITY SERVICES has a strong presence backed by 8 years of experienced leadership in the security solutions industry.
            Our team comprises ex-servicemen and professionally trained personnel safeguarding an impressive clientele including MNCs, hotels,
            educational institutions, IT & BPO sectors, Automobile & manufacturing units, pharma industries, hospitals, malls, and the jewellery segment.
          </p>
          <p>
            We provide well-trained, smartly uniformed, and constantly supervised security staff who prioritize the safety of personnel and property
            from pilferage, internal & external threats, fire, flood, and other risks. Every service is tailored to meet our client's exact security requirements based on the site specific conditions.
          </p>
        </div>
        <div className="about-image">
          {/* <img src={aboutImage} alt="Security Staff" /> */}
        </div>
      </div>

      {/* CEO Section */}
      <div className="about-section reverse">
        <div className="about-image">
          {/* <img src={ceoImage} alt="CEO" /> */}
        </div>
        <div className="about-text">
          <h2>Message from Our Director</h2>
          <p>
            We at SHIELDON SECURITY SERVICES, understand the importance of adapting technology with human intelligence. Our specialized services include
            managing safety systems like access control, CCTV surveillance, fire detection, intrusion alarms, and personal screening.
          </p>
          <p>
            With seamless integration between systems, we deliver actionable intelligence that responds only during real threats - enabling proactive
            risk mitigation and peace of mind for our clients.
          </p>
          <p className="ceo-sign">– Founder & Director, Shieldon Security Services</p>
        </div>
      </div>

    </section>
  );
};

export default About;
